 
import classNames from 'classnames';
import * as React from 'react';

export const Logo: React.FC<Props> = (props) =>
 <div className = "logo">{/*{classNames("logo", {"is-small-on-mobile": props.isSmallOnMobile})}> */}
    <div className = "logo__main">PRIME<span className = "logo__cursive">Kids</span></div> 
    <div className = "logo__title">{"LEARNING CENTER"}</div>
</div>

interface Props {
    isSmallOnMobile?: boolean;
}